/**
 * Where a company stands: 'active', 'suspended' (switched off by Suspend) or
 * 'pending' (never approved). Until 2 Nov 2026 suspending left no mark, so
 * every switched-off company read "Pending".
 */
export const tenantState = (tenant) => {
  if (tenant.is_active) return 'active';
  return tenant.suspended_at ? 'suspended' : 'pending';
};

export const TENANT_STATE_CHIP = {
  active: { label: 'Active', color: 'success' },
  suspended: { label: 'Suspended', color: 'error' },
  pending: { label: 'Pending', color: 'warning' },
};
